import { Component } from "react";
import type { DashboardObj, DashboardBaseObj } from "@/lib/models";

type Props = {
    selected: DashboardObj;
    dashboards: DashboardBaseObj[];
    handleDashboardClick: (dashboard: DashboardBaseObj) => void;
};

class DashboardList extends Component<Props> {
    handleDashboardClick(dashboard: DashboardBaseObj) {
        this.props.handleDashboardClick(dashboard);
    }

    render() {
        const dashboardList = this.props.dashboards.map((dashboard, i) => {
            let active_show = "nav-link";

            if (this.props.selected.uuid === dashboard.uuid) {
                active_show += " active show";
            }

            return (
                <li className="nav-item" key={i} onClick={() => this.handleDashboardClick(dashboard)}>
                    <a itemRef={"a" + i} className={active_show} href="#">
                        <span className="bold">{dashboard.title}</span>&nbsp;
                        {dashboard.is_system ? <span className="badge badge-warning">system</span> : null}&nbsp;
                        {dashboard.active ? <span className="badge badge-success">active</span> : null}&nbsp;
                        {dashboard.public ? <span className="badge badge-info">public</span> : null}
                    </a>
                </li>
            );
        });

        return (
            <ul className="nav nav-tabs">
                <div className="nav-tabs-parent">{dashboardList}</div>
            </ul>
        );
    }
}

export default DashboardList;
